let env = require("./../env.js");

export const Dlog = (...args) => {
  if (env.SHOWCONSOLELOGS) {
    console.log(...args);
  }
};
